import { AddOutlined } from "@qivia/ui";
import { t } from "i18next";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CreateDepartmentModal } from "./modals/createDepartmentModal";
import { SharedInterfaceDepartments } from "./sharedInterface";
import { DepartmentSidePanel } from "./sidePanel/SidePanel";
import { SidePanelDepartmentTypeDisplayed } from "./departmentsApi";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { selectCreateDepartmentOfCompanyStatus, getDepartmentsByCompanyAsync } from "./departmentsSlice";
import { selectCompany } from "../homeSlice";

export const Departments = () => {
  const env = import.meta.env["VITE_TARGET_ENV"] as string;
  const dispatch = useAppDispatch();
  const firstPath = location.pathname.split("/")[1]; 
  const navigate = useNavigate();
  const company = useAppSelector(selectCompany)
  const createDepartmentOfCompanyStatus = useAppSelector(selectCreateDepartmentOfCompanyStatus);

  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    if (env === "production") {
      navigate("/home");
    }
  }, [env, navigate]);

  const sidePanelAction = useCallback(
    (props: Partial<SidePanelDepartmentTypeDisplayed>) => {
      navigate(`/${firstPath}/departments/${props.id}`);
    },
    [firstPath, navigate],
  );

  useEffect(() => {
    if (company && createDepartmentOfCompanyStatus === "success") {
      void dispatch(getDepartmentsByCompanyAsync(company.uuid));
      setIsModalVisible(false);
    }
  }, [company, createDepartmentOfCompanyStatus, dispatch])

  const cta = {
    title: t("departments.cta"),
    action: () => {
      setIsModalVisible(true)
    },
    width: 12,
    leftIcon: <AddOutlined />,
  };

  return (
    <>
      <CreateDepartmentModal
        visible={isModalVisible}
        onCloseModal={() => {
          setIsModalVisible(false);
        }}
      />
      <SharedInterfaceDepartments 
        cta={cta}
        sidePanelAction={sidePanelAction}
        sidePanel={
          <DepartmentSidePanel
            canAddVehicle
            canDeactivate        
          />
        }
      />
    </>
  );
};
